import { render, staticRenderFns } from "./PrivacyInformationC.vue?vue&type=template&id=40e92608&"
import script from "./PrivacyInformationC.vue?vue&type=script&lang=js&"
export * from "./PrivacyInformationC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports